// extracted by mini-css-extract-plugin
export default {"container":"TableNoResults__container-N9d0S","errorInfo":"TableNoResults__errorInfo-zHfy8"};